module.exports = __webpack_public_path__ + "static/grafika3@2x-3c317472f4252ed02d6e002178fc30b3.png";